export const BladesPolicy = {
    STRICT: 'STRICT',
    STANDARD: 'STANDARD'
}

export const TraficType = {
    ALL: 'All',
    OUTGOING: 'Outgoing',
    INCOMING: 'Incoming'
}
